import { queryOptions, useQuery } from "@tanstack/react-query";
import { supabaseClient } from "@/lib/supabase";

export async function selectTemplates() {
    const { data: available, error: availableError } = await supabaseClient
        .from("available_schedules")
        .select("schedule_id")
        .throwOnError();
    if (availableError) throw availableError;

    const scheduleIds = (available ?? []).map((row) => row.schedule_id).filter((id): id is string => Boolean(id));
    if (scheduleIds.length === 0) return [];

    const { data, error } = await supabaseClient
        .from("schedules")
        .select("*, timings(*)")
        .in("schedule_id", scheduleIds)
        .throwOnError();
    if (error) throw error;
    return data;
}

export const templatesQueryKey = ["schedules", "available"];

export const schedulesQueryOptions = () => {
    return queryOptions({
        queryKey: templatesQueryKey,
        queryFn: () => selectTemplates(),
        // Invalidated by schedule mutations on `["schedules"]`. Avoid refetching the
        // full picker (available_schedules + timings) on every template wizard step.
        staleTime: 5 * 60_000,
        gcTime: Number.POSITIVE_INFINITY,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });
};

export const useSchedulesQuery = () => {
    const options = schedulesQueryOptions();
    const query = useQuery(options);
    return query;
};
